import {Component} from 'react'
import {TbDashboard, TbEmpathize, TbMessageUser, TbReservedLine} from 'react-icons/tb'
import {LuHandHelping, LuListTree, LuUserCog, LuUsers} from 'react-icons/lu'
import {GoVersions} from 'react-icons/go'
import * as Md from 'react-icons/md'
import {AiOutlineQuestionCircle} from 'react-icons/ai'
import * as Fa from 'react-icons/fa'
import * as Fa6 from 'react-icons/fa6'
import {PiBuilding, PiPackageFill} from 'react-icons/pi'
import {RiCalendarScheduleLine, RiHotelLine} from 'react-icons/ri'
import * as Hi from 'react-icons/hi'
import {IoAirplane, IoBusiness} from 'react-icons/io5'
import {BsPlugin} from "react-icons/bs";
import * as IconSax from 'iconsax-reactjs';
import {BiBarChartSquare} from "react-icons/bi";
import TcBeach from "@/assets/icons/TcBeach.jsx"
import {TfiLayoutSliderAlt, TfiLayoutSlider} from "react-icons/tfi";
import {Wallet1} from "iconsax-reactjs";
import TcRoadTrip from "../../assets/icons/TcRoadTrip";

export const icons = {
    TbMessageUser: TbMessageUser,
    LuUsers: LuUsers,
    LuListTree: LuListTree,
    LuUserCog: LuUserCog,
    GoVersions: GoVersions,
    AiOutlineQuestionCircle: AiOutlineQuestionCircle,
    PiBuilding: PiBuilding,
    RiHotelLine: RiHotelLine,
    RiCalendarScheduleLine: RiCalendarScheduleLine,
    IoBusiness: IoBusiness,
    TbDashboard: TbDashboard,
    IoAirplane: IoAirplane,
    PiPackageFill: PiPackageFill,
    TbReservedLine: TbReservedLine,
    BsPlugin: BsPlugin,
    BiBarChartSquare: BiBarChartSquare,
    TfiLayoutSliderAlt: TfiLayoutSliderAlt,
    TfiLayoutSlider: TfiLayoutSlider,
    TbEmpathize: TbEmpathize,
    LuHandHelping: LuHandHelping,
    // ...IconSax,
    ...Fa,
    ...Fa6,
    ...Md,
    ...Hi,
    Wallet1: <Wallet1/>,
    TcBeach: TcBeach,
    TcRoadTrip: TcRoadTrip,
}

/**
 * Resolves a string identifier to a React component.
 * @param {string} iconString - Icon name as a string (e.g., "FaHome").
 * @returns {React.Component|undefined} - The corresponding React component, or undefined if not found.
 */
export const getIconComponent = ({icon, ...props}) => {
    if (typeof icon != 'string') return icon
    if (!icon || typeof icon != 'string') return undefined

    let Icon = icons[icon]

    // console.log(`icon of ${icon}:`, typeof Icon, Icon);

    if (!icon) return null

    if (typeof Icon == "object")
        return Icon

    if (typeof Icon == "function")
        return <Icon {...props} /> || Icon?.(props)

    return Icon
}

export const getIconIdentifier = (icon) => {
    // console.error('icon id is:', icon?.type?.name)
    // console.log('icon:', icon)
    // for (const library of Object.values(iconLibraries)) {
    //     for (const [key, value] of Object.entries(library)) {
    //
    //         if (value == icon) {
    //             console.log('key:', key)
    //             console.log('value:', value)
    //             return key;
    //         }
    //     }
    // }

    return icon?.type?.name
}

export const IconComponent = ({icon, ...props}) => {
    if (!icon) return
    // console.log('icon id:', icon)
    if (typeof icon == "string" && (icon?.startsWith("http://") || icon?.startsWith("https://")))
        return <img src={icon} {...props} />

    return getIconComponent({icon, ...props})
}

export const Sax = IconSax;
